import { GALLERY_NAV_DRAWER_LINKS } from '@/consts/gallery-nav-data';
import { NEWS_MEDIA_NAV_DRAWER_LINKS } from '@/consts/news-media-nav-data';
import { STUDIO_NAV_DRAWER_LINKS } from '@/consts/studio-nav-data';
import { TRADE_NAV_DRAWER_LINKS } from '@/consts/trade-nav-data';
import {
  BOOK_ONLINE_PATH,
  CONTACT_PATH,
  EVENT_FORM_PATH,
  OUR_PROCESS_PATH,
  THE_BRAND_PATH,
} from '@/consts/routes';

/** Shared marketing nav tree (desktop dropdowns + mobile drawer). */
export const MARKETING_NAV_TREE = [
  { label: 'The Brand', href: THE_BRAND_PATH },
  { label: 'Our Process', href: OUR_PROCESS_PATH },
  {
    label: 'Portfolio',
    megaMenu: 'gallery',
    children: GALLERY_NAV_DRAWER_LINKS,
  },
  {
    label: 'News & Media',
    megaMenu: 'newsMedia',
    children: NEWS_MEDIA_NAV_DRAWER_LINKS,
  },
  {
    label: 'Trade',
    megaMenu: 'trade',
    children: TRADE_NAV_DRAWER_LINKS,
  },
  {
    label: 'Careers',
    megaMenu: 'studio',
    children: STUDIO_NAV_DRAWER_LINKS,
  },
  { label: 'Book Online', href: BOOK_ONLINE_PATH },
];

/** Overflow links opened via the menu drawer (desktop) or full mobile drawer. */
export const MARKETING_NAV_MENU_ITEMS = [
  { label: 'Contact', href: CONTACT_PATH },
  { label: 'Event Registration', href: EVENT_FORM_PATH },
];

/** Home hero — same tree without a leading Home link (logo links home). */
export const HOME_NAV_ITEMS_BASE = MARKETING_NAV_TREE;

/** Interior marketing pages — same tree as home hero (logo links home). */
export const MARKETING_INTERIOR_NAV_ITEMS_BASE = MARKETING_NAV_TREE;

/** Flatten nav tree for mobile drawer (section headers + indented children). */
export function flattenNavItemsForDrawer(items) {
  const flat = [];
  items.forEach(item => {
    if (item.children?.length) {
      flat.push({ type: 'section', label: item.label, key: `section:${item.label}` });
      item.children.forEach(child => {
        flat.push({
          ...child,
          inset: true,
          group: item.label,
          variant: child.variant ?? 'link',
        });
      });
    } else if (item.href) {
      flat.push(item);
    }
  });
  return flat;
}
